import { Grid, Typography } from '@mui/material';
import { Outlet } from 'react-router';
import { SystemPageTabs } from '~/pages/layout/components/Navigation/SystemPageTabs';
import { SimulationInfoBar } from '~/pages/layout/components/Navigation/SimulationInfoBar';
import { SystemSelect } from '~/pages/layout/components/SystemSelect/SystemSelect';
import { useRequiredSystem } from '~/shared/hooks/system-hooks';
import { useSimulationInfo } from '~/shared/hooks/useSimulationInfo';
import { useAuthUser } from '~/shared/hooks/auth-hooks';

export function SystemPageLayout() {
  const currentSystem = useRequiredSystem();
  const { isSimulation } = useSimulationInfo();
  const authUser = useAuthUser();

  const renderSystemDropdown = () => {
    if (!authUser?.canSeeSystemsDropdown) {
      return null;
    }

    return <SystemSelect />;
  };

  return (
    <>
      <style>
        {`
            html {
            scrollbar-gutter: stable;
            }
          `}
      </style>
      <Grid
        container
        spacing={2}
        sx={{
          alignItems: 'center',
        }}
      >
        <Grid
          size={{
            xs: 12,
            sm: 'grow',
          }}
        >
          <Typography
            variant="display-m"
            sx={{
              typography: {
                xs: 'display-s',
                sm: 'display-m',
              },
            }}
          >
            {currentSystem.title}
          </Typography>
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 'auto',
          }}
        >
          {!isSimulation ? renderSystemDropdown() : <SimulationInfoBar />}
        </Grid>

        <Grid size={12}>
          <SystemPageTabs />
        </Grid>
      </Grid>
      <Outlet />
    </>
  );
}
